module.exports = __webpack_public_path__ + "img/bank-yapikredi.f9217ffe.svg";